'use client';
import { useMemo } from 'react';
import { classNames } from '@repo/ui/src/utils/classNames';

interface Props {
  darkMode?: boolean;
  slideCount: number;
  totalSlides: number;
  selectedIndex: number;
}

const AnimatedSlider = ({ darkMode, slideCount, totalSlides, selectedIndex }: Props) => {
  const width = useMemo(
    () => (totalSlides ? (slideCount / totalSlides) * 100 : 100),
    [slideCount, totalSlides],
  );
  const left = useMemo(() => {
    if (!totalSlides) return 0;
    const steps = totalSlides - slideCount;
    if (steps <= 0) return 0;
    const stepWidth = (100 - width) / steps;
    const containerPercent = Math.min(selectedIndex, steps) * stepWidth;
    const multiplier = 100 / width;
    return containerPercent * multiplier;
  }, [selectedIndex, totalSlides, slideCount, width]);

  return (
    <div>
      <div
        className={classNames(
          'h-1 mb-0.5 w-full translate-y-2',
          darkMode ? 'bg-transparent-dark-200' : 'bg-transparent-light-200',
        )}
      ></div>
      <div
        className={classNames(
          ' h-2 relative transition-transform duration-500 ease-in left-0',
          darkMode ? 'bg-neutral-100' : 'bg-neutral-700',
        )}
        style={{ width: `${width}%`, transform: `translateX(${left}%)` }}
      />
    </div>
  );
};

export default AnimatedSlider;
